<template>
  <!-- 服务协议组件 -->
  <div class="agreementContent">
    <div class="title">
      <p>{{ $t('agreement.title1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</p>
      <p>{{ $t('agreement.welcome', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</p>
      <p>
        {{ $t('agreement.intro1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
        <strong>{{ $t('agreement.intro2', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</strong>
      </p>
      <strong>{{ $t('agreement.intro3', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</strong>
    </div>
    <div>
      <h1>{{ $t('agreement.section1.title') }}</h1>
      <p>
        {{ $t('agreement.section1.p1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>
        {{ $t('agreement.section1.p2', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>
        {{ $t('agreement.section1.p3') }}
      </p>
    </div>
    <div>
      <h1>{{ $t('agreement.section2.title') }}</h1>
      <p>
        {{ $t('agreement.section2.p1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>
        {{ $t('agreement.section2.p2', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
        <a href="https://cloud.tencent.com/register?s_url=https%3A%2F%2Fcloud.tencent.com%2F"
           target="_blank">{{ $t('agreement.section2.register') }}</a>、
        {{ $t('agreement.section2.p2_suffix') }}
      </p>
      <p>
        {{ $t('agreement.section2.p3', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>
        {{ $t('agreement.section2.p4') }}
      </p>
      <p>
        {{ $t('agreement.section2.p5', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>
        {{ $t('agreement.section2.p6') }}
      </p>
      <p>
        {{ $t('agreement.section2.p7') }}
      </p>
    </div>
    <div>
      <h1>{{ $t('agreement.section3.title') }}</h1>
      <h3>{{ $t('agreement.section3.sub1.title') }}</h3>
      <p>
        {{ $t('agreement.section3.sub1.p1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>
        {{ $t('agreement.section3.sub1.p2', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>{{ $t('agreement.section3.sub1.p3', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</p>
      <h3>{{ $t('agreement.section3.sub2.title') }}</h3>
      <p>
        {{ $t('agreement.section3.sub2.p1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <h3>{{ $t('agreement.section3.sub3.title') }}</h3>
      <p>
        {{ $t('agreement.section3.sub3.p1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>
        {{ $t('agreement.section3.sub3.p2') }}
      </p>
      <p>
        {{ $t('agreement.section3.sub3.p3', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>{{ $t('agreement.section3.sub3.p4') }}</p>
      <h3>{{ $t('agreement.section3.sub4.title') }}</h3>
      <p>
        {{ $t('agreement.section3.sub4.p1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>
        {{ $t('agreement.section3.sub4.p2', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>
        {{ $t('agreement.section3.sub4.p3', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>
        {{ $t('agreement.section3.sub5.p1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <h3>{{ $t('agreement.section3.sub6.title') }}</h3>
      <p>
        {{ $t('agreement.section3.sub6.p1') }}
      </p>
      <p>
        {{ $t('agreement.section3.sub6.p2') }}
      </p>
      <p>{{ $t('agreement.section3.sub6.p3') }}</p>
    </div>
    <div>
      <h1>{{ $t('agreement.section4.title') }}</h1>
      <p>{{ $t('agreement.section4.p1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</p>
      <p>
        {{ $t('agreement.section4.p2', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>{{ $t('agreement.section4.p2_1') }}</p>
      <p>{{ $t('agreement.section4.p2_2') }}</p>
      <p>{{ $t('agreement.section4.p2_3') }}</p>
      <p>{{ $t('agreement.section4.p2_4') }}</p>
      <p>{{ $t('agreement.section4.p2_5') }}</p>
      <p>{{ $t('agreement.section4.p2_6') }}</p>
      <p>{{ $t('agreement.section4.p2_7') }}</p>
      <p>{{ $t('agreement.section4.p2_8') }}</p>
      <p>{{ $t('agreement.section4.p2_9') }}</p>
      <p>{{ $t('agreement.section4.p2_10') }}</p>
      <p>{{ $t('agreement.section4.p3', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</p>
      <p>{{ $t('agreement.section4.p3_1') }}</p>
      <p>{{ $t('agreement.section4.p3_2') }}</p>
      <p>{{ $t('agreement.section4.p3_3') }}</p>
      <p>{{ $t('agreement.section4.p3_4') }}</p>
      <p>{{ $t('agreement.section4.p3_5') }}</p>
      <p>{{ $t('agreement.section4.p3_6') }}</p>
    </div>
    <div>
      <p>{{ $t('agreement.section5.p1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</p>
      <p>
        {{ $t('agreement.section5.p2', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>{{ $t('agreement.section5.p2_1') }}</p>
      <p>{{ $t('agreement.section5.p2_2') }}</p>
      <p>{{ $t('agreement.section5.p2_3') }}</p>
      <p>{{ $t('agreement.section5.p2_4') }}</p>
      <p>
        {{ $t('agreement.section5.p3', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>{{ $t('agreement.section5.p3_1') }}</p>
      <p>{{ $t('agreement.section5.p3_2', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</p>
      <p>{{ $t('agreement.section5.p3_3', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</p>
      <p>{{ $t('agreement.section5.p3_4') }}</p>
      <p>
        {{ $t('agreement.section5.p4', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>
        {{ $t('agreement.section5.p5') }}
      </p>
      <p>{{ $t('agreement.section5.p6') }}</p>
    </div>
    <div>
      <h1>{{ $t('agreement.section6.title') }}</h1>
      <p>
        {{ $t('agreement.section6.p1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>
        {{ $t('agreement.section6.p2', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <div>
        <p>{{ $t('agreement.section6.p3', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</p>
        <p>{{ $t('agreement.section6.p3_1') }}</p>
        <p>{{ $t('agreement.section6.p3_2') }}</p>
        <p>{{ $t('agreement.section6.p3_3') }}</p>
        <p>{{ $t('agreement.section6.p3_4') }}</p>
        <p>{{ $t('agreement.section6.p3_5') }}</p>
        <p>{{ $t('agreement.section6.p3_6') }}</p>
      </div>
      <div>
        <p>{{ $t('agreement.section6.p4', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</p>
        <p>{{ $t('agreement.section6.p4_1') }}</p>
        <p>{{ $t('agreement.section6.p4_2') }}</p>
        <p>{{ $t('agreement.section6.p4_3') }}</p>
        <p>{{ $t('agreement.section6.p4_4') }}</p>
        <p>{{ $t('agreement.section6.p4_5') }}</p>
        <p>{{ $t('agreement.section6.p4_6') }}</p>
      </div>
      <strong>{{ $t('agreement.section6.p5', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</strong>
      <p>
        {{ $t('agreement.section6.p6', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <p>
        {{ $t('agreement.section6.p7', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
      <strong>{{ $t('agreement.section6.p8') }}</strong>
      <p>
        {{ $t('agreement.section6.p9', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
    </div>
    <div>
      <h1>{{ $t('agreement.section7.title') }}</h1>
      <p>
        {{ $t('agreement.section7.p1') }}
      </p>
      <p>
        {{ $t('agreement.section7.p2') }}
      </p>
      <p>
        {{
          $t('agreement.section7.p3', {
            service: $t(isEda ? 'agreement.eda' : 'agreement.cae'),
            software: $t(isEda ? 'agreement.eda' : 'agreement.cae')
          })
        }}
      </p>
      <p>
        {{ $t('agreement.section7.p4') }}
      </p>
      <p>
        {{ $t('agreement.section7.p5', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
    </div>
    <div>
      <h1>{{ $t('agreement.section8.title') }}</h1>
      <p>{{ $t('agreement.section8.p1') }}</p>
      <p>
        {{ $t('agreement.section8.p2') }}
      </p>
      <p>
        {{ $t('agreement.section8.p3') }}
      </p>
      <p>{{ $t('agreement.section8.p4') }}</p>
      <p>{{ $t('agreement.section8.p4_1') }}</p>
      <p>{{ $t('agreement.section8.p4_2') }}</p>
      <p>{{ $t('agreement.section8.p4_3') }}</p>
      <p>{{ $t('agreement.section8.p4_4') }}</p>
      <p>
        {{ $t('agreement.section8.p5') }}
      </p>
      <p>{{ $t('agreement.section8.p6') }}</p>
      <p>{{ $t('agreement.section8.p7') }}</p>
    </div>
    <div>
      <h1>{{ $t('agreement.section9.title') }}</h1>
      <p>
        {{ $t('agreement.section9.p1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}
      </p>
    </div>
    <div>
      <h1>{{ $t('agreement.section10.title') }}</h1>
      <p>
        <strong>{{ $t('agreement.section10.p1', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</strong>
      </p>
      <p>
        <strong>{{ $t('agreement.section10.p1_1') }}</strong>
      </p>
      <p>
        <strong>{{ $t('agreement.section10.p1_2') }}</strong>
      </p>
      <p>
        <strong>{{ $t('agreement.section10.p1_3') }}</strong>
      </p>
      <p>
        <strong>{{ $t('agreement.section10.p1_4', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</strong>
      </p>
      <p>
        <strong>{{ $t('agreement.section10.p1_5') }}</strong>
      </p>
      <p>
        <strong>{{ $t('agreement.section10.p2') }}</strong>
      </p>
      <p>
        <strong>{{ $t('agreement.section10.p3', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</strong>
      </p>
      <p>
        <strong>{{ $t('agreement.section10.p4') }}</strong>
      </p>
      <p>
        <strong>{{ $t('agreement.section10.p5', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</strong>
      </p>
    </div>
    <div>
      <h1>{{ $t('agreement.section11.title') }}</h1>
      <p>{{ $t('agreement.section11.p1') }}</p>
      <p>{{ $t('agreement.section11.p2', {email: 'qlab@tencent.com'}) }}</p>
      <p>{{ $t('agreement.section11.p3', {service: $t(isEda ? 'agreement.eda' : 'agreement.cae')}) }}</p>
      <p>{{ $t('agreement.section11.p3_1') }}</p>
      <p>{{ $t('agreement.section11.p3_2') }}</p>
      <p>{{ $t('agreement.section11.p3_3') }}</p>
      <p>{{ $t('agreement.section11.p3_4') }}</p>
    </div>
    <div>
      <h1>{{ $t('agreement.section12.title') }}</h1>
      <strong>{{ $t('agreement.section12.p1') }}</strong>
      <p>{{ $t('agreement.section12.p2') }}</p>
      <strong>{{ $t('agreement.section12.p3') }}</strong>
    </div>
    <div>
      <h1>{{ $t('agreement.section13.title') }}</h1>
      <p>{{ $t('agreement.section13.p1') }}</p>
      <p>{{ $t('agreement.section13.p2') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agreement',
  data() {
    return {
      isEda: window.location.host.includes('eda'),
    };
  },
};
</script>

<style lang="scss" scoped>
// 内容
.agreementContent {
  overflow-y: auto;
  height: 610px;
  white-space: pre-line;
  font-size: 16px;
  text-align: left;
  color: #000;
}

// 名称
.title {
  p {
    margin-bottom: 10px;
  }
}

h1, h3 {
  margin-top: 20px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
  font-weight: 400;
  font-family: "PingFang SC";
  line-height: 30px;
}

h3 {
  margin-top: 0;
}

p {
  margin-bottom: 6px;
}
</style>
